import { FINGERPRINT } from 'store/constants';
import { softLocalStorageSet } from 'utils/storage';

export const setFingerprint: VoidFunction = async (): Promise<void> => {
  const { load } = await import('@fingerprintjs/fingerprintjs');
  const fp = await load();
  const result = await fp.get();

  softLocalStorageSet(FINGERPRINT, result.visitorId);
};
